import React from 'react';
import { FluentProvider } from '@fluentui/react-components';

import { getTheme } from 'src/utils/theme';
import useTeamsFx from 'src/hooks/useTeamsFx';

interface FluentProviderWrapperProps {
  children: React.ReactNode
}

export const FluentProviderWrapper: React.FC<FluentProviderWrapperProps> = ({ children }) => {
  const { themeString } = useTeamsFx();
  const theme = getTheme(themeString);

  return <FluentProvider theme={theme}>{children}</FluentProvider>;
};

export default FluentProviderWrapper;
